import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-model-m",
  "use": "icon-model-m-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-model-m\">\n    <path d=\"M1.714 5.697 8 9.887v6.287l-6.286-4.191V5.697z\" fill=\"#8394EE\" />\n    <path d=\"M1.714 5.697 8 9.887l6.286-4.19L8 1.507l-6.286 4.19z\" fill=\"#B3BFFF\" />\n    <path d=\"M14.286 5.697 8 9.887v6.287l6.286-4.191V5.697z\" fill=\"#2F54EB\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol